import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

function ListItem({ children, className }) {
  const listItemClassName = classnames("list__item", className);

  return <li className={listItemClassName}>{children}</li>;
}

ListItem.propTypes = {
  className: PropTypes.string,
};

export default ListItem;
